/* NOTE: This mimics what we do in webapp and links to our custom version of
React -- this was not added with npm */
module.exports = require("react").__internalAddons.PureRenderMixin;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-pure-render-mixin/index.js
 ** module id = 270
 ** module chunks = 0 2
 **/